export default __webpack_public_path__ + "static/media/sports02.6fa936fe.png";